function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoadingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.7958 59.284L73.1289 17.2812C73.371 16.7812 73.0067 16.2002 72.4513 16.2002H65.1297L48.9287 51.1015L52.7958 59.284ZM42.4213 37.332L51.8259 17.072C52.0727 16.5403 52.6056 16.2002 53.1917 16.2002H60.7531L46.4237 45.8009L42.4213 37.332Z",
    fill: "#11B0C6",
    style: {
      fill: "#11B0C6",
      fill: "color(display-p3 0.0667 0.6902 0.7765)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.5285 63.1621L7.31803 17.2812C7.07598 16.7812 7.44021 16.2002 7.99571 16.2002H15.3172L37.4126 63.7994H30.5451C30.1121 63.7994 29.7172 63.5518 29.5285 63.1621Z",
    fill: "#11B0C6",
    style: {
      fill: "#11B0C6",
      fill: "color(display-p3 0.0667 0.6902 0.7765)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.5353 63.7994L19.493 16.2002H27.0543C27.6405 16.2002 28.1734 16.5403 28.4202 17.072L50.1108 63.7994H42.5353Z",
    fill: "#11B0C6",
    style: {
      fill: "#11B0C6",
      fill: "color(display-p3 0.0667 0.6902 0.7765)",
      fillOpacity: 1
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoadingIcon);
export default __webpack_public_path__ + "static/media/loadingIcon.32e3d4dc9c441b7e3984e29cd51290b9.svg";
export { ForwardRef as ReactComponent };